import React from 'react';
import {observer} from 'mobx-react';
import {withState} from 'shared/core';
import {FormattedMessage} from 'react-intl';
import _ from 'lodash';
import TypePolicyModalState from '../state/TypePolicyModalState';

const LiabilityCalculationModalContent = observer(({uiState, selectedLiabilityBalance}) => {
  const {typePolicy} = uiState;

  return (
    <div>
      <div className='jumbo mb2'>
        <FormattedMessage id={_.get(typePolicy, 'accrueUpfront') ? 'employees.profile.time_off.liability.LIABILITY_EXPLAINER_UPFRONT' : 'employees.profile.time_off.liability.LIABILITY_EXPLAINER_END_OF_PERIOD'}/>
      </div>
      <div className='flex mb1'>
        <div className='col-1'></div>
        <div className='col-11'>
          {selectedLiabilityBalance.availableView}
          <span className='jumbo' style={{marginLeft: '0.25rem'}}>
            <FormattedMessage id='employees.profile.time_off.liability.available'/>
          </span>
        </div>
      </div>
      <div className='flex mb1'>
        <div className='col-1'>{selectedLiabilityBalance.accrualAdjustment < 0 ? '-' : '+'}</div>
        <div className='col-11'>
          {selectedLiabilityBalance.absoluteAccrualAdjustmentView}
          <span className='jumbo' style={{marginLeft: '0.25rem'}}>
            <FormattedMessage id='employees.profile.time_off.liability.ACCRUAL_ADJUSTMENT_PERIOD' values={{range: selectedLiabilityBalance.accrualAdjustmentPeriodDateRange}}/>
          </span>
        </div>
      </div>
      {selectedLiabilityBalance.scheduled > 0 && <div className='flex mb1'>
        <div className='col-1'>{'+'}</div>
        <div className='col-11'>
          {selectedLiabilityBalance.scheduledView}
          <span className='jumbo' style={{marginLeft: '0.25rem'}}>
            <FormattedMessage id='employees.profile.time_off.liability.SCHEDULED_TIME_OFF' values={{date: selectedLiabilityBalance.lastDayOfWorkView}}/>
          </span>
        </div>
      </div>}
      <hr className='my1 border--whale'/>
      <div className='flex'>
        <div className='col-1'></div>
        <div className='col-11'>
          {selectedLiabilityBalance.totalLiabilityView}
          <span className='jumbo' style={{marginLeft: '0.25rem'}}>
            <FormattedMessage id='employees.profile.time_off.liability.final balance'/>
          </span>
        </div>
      </div>
    </div>
  );
});

export default withState(LiabilityCalculationModalContent, TypePolicyModalState);
